import React from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import styles from "./BlossomLegend.module.css";

export type BlossomLegendProps = {
  maxDensity: number;
  minDensity: number;
};

export default function BlossomLegend({
  maxDensity,
  minDensity,
}: BlossomLegendProps): React.ReactNode {
  const { t } = useTranslation();
  return (
    <aside className={`${styles.blossomLegend} boxed`}>
      <h1 className={styles.heading}>{t("heading.Blossom area")}</h1>

      <Box className={styles.gradientBox}></Box>

      <Grid container justifyContent="center">
        <Grid size={{ xs: 6 }}>
          <p> {minDensity}</p>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <p style={{ textAlign: "right" }}>{maxDensity}</p>
        </Grid>
      </Grid>
    </aside>
  );
}
